// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-circle {
  width: 285px;
  height: 285px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.5s ease;
}

.progress-circle-inner {
  width: 85%;
  height: 85%;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  padding: 8px;
  box-sizing: border-box;
  transition: all 0.5s ease;
}

.progress-percentage1-inner {
  font-size: 2rem;
  font-weight: bold;
  color: #fff;
  line-height: 1.2;
}

.progress-percentage1-inner .big {
  font-size: 2rem;
  font-weight: bold;
  color: #fff;
}

.progress-metrics {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.progress-metrics .metric {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.progress-metrics .label {
  color: #fff;
  font-size: 0.75rem;
  line-height: 1.1;
}

.metric .value {
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
}

@media (max-width: 1024px) {
  .progress-circle {
    width: 250px;
    height: 250px;
  }

  .progress-circle-inner {
    width: 85%;
    height: 85%;
  }

  .progress-percentage1-inner,
  .progress-percentage1-inner .big {
    font-size: 1.8rem;
  }

  .metric .value {
    font-size: 1.1rem;
  }
}

@media (max-width: 768px) {
  .progress-circle {
    width: 200px;
    height: 200px;
  }

  .progress-percentage1-inner,
  .progress-percentage1-inner .big {
    font-size: 1.4rem;
  }

  .metric .value {
    font-size: 1rem;
  }

  .progress-metrics .label {
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .progress-circle {
    width: 160px;
    height: 160px;
  }

  .progress-percentage1-inner,
  .progress-percentage1-inner .big {
    font-size: 1.2rem;
  }

  .metric .value {
    font-size: 0.9rem;
  }

  .progress-metrics .label {
    font-size: 0.65rem;
  }
}


@keyframes progressUpdate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.progress-circle.updated {
  animation: progressUpdate 0.3s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/app/Shared/Pages/circularprogress/circularprogress.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".progress-circle {\n  width: 285px;\n  height: 285px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: all 0.5s ease;\n}\n\n.progress-circle-inner {\n  width: 85%;\n  height: 85%;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  position: absolute;\n  padding: 8px;\n  box-sizing: border-box;\n  transition: all 0.5s ease;\n}\n\n.progress-percentage1-inner {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #fff;\n  line-height: 1.2;\n}\n\n.progress-percentage1-inner .big {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #fff;\n}\n\n.progress-metrics {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.progress-metrics .metric {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.progress-metrics .label {\n  color: #fff;\n  font-size: 0.75rem;\n  line-height: 1.1;\n}\n\n.metric .value {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #fff;\n}\n\n@media (max-width: 1024px) {\n  .progress-circle {\n    width: 250px;\n    height: 250px;\n  }\n\n  .progress-circle-inner {\n    width: 85%;\n    height: 85%;\n  }\n\n  .progress-percentage1-inner,\n  .progress-percentage1-inner .big {\n    font-size: 1.8rem;\n  }\n\n  .metric .value {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .progress-circle {\n    width: 200px;\n    height: 200px;\n  }\n\n  .progress-percentage1-inner,\n  .progress-percentage1-inner .big {\n    font-size: 1.4rem;\n  }\n\n  .metric .value {\n    font-size: 1rem;\n  }\n\n  .progress-metrics .label {\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .progress-circle {\n    width: 160px;\n    height: 160px;\n  }\n\n  .progress-percentage1-inner,\n  .progress-percentage1-inner .big {\n    font-size: 1.2rem;\n  }\n\n  .metric .value {\n    font-size: 0.9rem;\n  }\n\n  .progress-metrics .label {\n    font-size: 0.65rem;\n  }\n}\n\n\n@keyframes progressUpdate {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.progress-circle.updated {\n  animation: progressUpdate 0.3s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
